var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 14.6666C0.666626 13.2521 1.22853 11.8956 2.22872 10.8954C3.22892 9.8952 4.58547 9.33329 5.99996 9.33329C7.41445 9.33329 8.771 9.8952 9.7712 10.8954C10.7714 11.8956 11.3333 13.2521 11.3333 14.6666H9.99996C9.99996 13.6058 9.57853 12.5883 8.82839 11.8382C8.07824 11.0881 7.06082 10.6666 5.99996 10.6666C4.93909 10.6666 3.92168 11.0881 3.17153 11.8382C2.42139 12.5883 1.99996 13.6058 1.99996 14.6666H0.666626ZM5.99996 8.66663C3.78996 8.66663 1.99996 6.87663 1.99996 4.66663C1.99996 2.45663 3.78996 0.666626 5.99996 0.666626C8.20996 0.666626 9.99996 2.45663 9.99996 4.66663C9.99996 6.87663 8.20996 8.66663 5.99996 8.66663ZM5.99996 7.33329C7.47329 7.33329 8.66663 6.13996 8.66663 4.66663C8.66663 3.19329 7.47329 1.99996 5.99996 1.99996C4.52663 1.99996 3.33329 3.19329 3.33329 4.66663C3.33329 6.13996 4.52663 7.33329 5.99996 7.33329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7e9b760fd1753d968878d499c0de0814.svg";
export { ForwardRef as ReactComponent };